'use strict';

exports.__esModule = true;
exports.CARD_RADII = exports.CARD_ELEVATIONS = exports.CARD_VARIANTS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CardStyled = require('./CardStyled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// React-Wrapper-Pflichtmuster (wie CircleBadge.jsx): reicht `className` durch,
// damit Konsumenten via styled(Card) ihr Layout ergänzen können. `as` erlaubt
// Polymorphie (div/Link/NavLink/li) für klickbare Karten.
var CARD_VARIANTS = exports.CARD_VARIANTS = { SURFACE: 'surface', NAVY: 'navy', PLAIN: 'plain' };
var CARD_ELEVATIONS = exports.CARD_ELEVATIONS = {
  NONE: 'none', SM: 'sm', MD: 'md', LG: 'lg'
};
var CARD_RADII = exports.CARD_RADII = {
  NONE: 'none', SM: 'sm', MD: 'md', LG: 'lg'
};

// Klickbare Karten (Applicant/BottomLinks): NICHT `as` an styled(Card) geben — v4
// faengt `as` am styled-Wrapper ab und ersetzt damit Card selbst (Optik geht
// verloren). Stattdessen `forwardedAs` nutzen; styled-components reicht es als `as`
// an Card durch -> hier landet es an CardBox (verifiziert in CardPrimitive.test.js).
var Card = function Card(_ref) {
  var className = _ref.className,
      children = _ref.children,
      variant = _ref.variant,
      elevation = _ref.elevation,
      radius = _ref.radius,
      bordered = _ref.bordered,
      interactive = _ref.interactive,
      as = _ref.as,
      rest = _objectWithoutProperties(_ref, ['className', 'children', 'variant', 'elevation', 'radius', 'bordered', 'interactive', 'as']);

  return _react2.default.createElement(
    _CardStyled.CardBox,
    _extends({
      className: className,
      as: as,
      variant: variant,
      elevation: elevation,
      radius: radius,
      bordered: bordered,
      interactive: interactive
    }, rest),
    children
  );
};

Card.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  variant: _propTypes2.default.oneOf(Object.values(CARD_VARIANTS)),
  elevation: _propTypes2.default.oneOf(Object.values(CARD_ELEVATIONS)),
  radius: _propTypes2.default.oneOf(Object.values(CARD_RADII)),
  bordered: _propTypes2.default.bool,
  interactive: _propTypes2.default.bool,
  as: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.elementType])
} : {};

Card.defaultProps = {
  className: undefined,
  children: null,
  variant: CARD_VARIANTS.SURFACE,
  elevation: CARD_ELEVATIONS.MD,
  radius: CARD_RADII.MD,
  bordered: false,
  interactive: false,
  as: undefined
};

exports.default = Card;